import { useState, useEffect } from "react";

export const useWebSocket = (socket) => {
  const [isMicAvailable, setIsMicAvailable] = useState(true);

  // Now transcription is a single final string, not an array of lines
  const [transcription, setTranscription] = useState("");
  const [interimTranscription, setInterimTranscription] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!socket) {
      console.log("[Socket] !socket");
      return;
    }

    console.log("[Socket] connected, registering event listeners");

    socket.on("connect", () => {
      console.log("[Socket] Connected:", socket.id);
    });

    socket.on("connect_error", (err) => {
      console.error("[Socket] connect_error", err);
    });

    socket.on("mic_status", ({ occupied }) => {
      setIsMicAvailable(!occupied);
    });

    // Partial: already includes final_text + current partial
    socket.on("transcriptPartial", (msg) => {
      const text = msg.data || "";
      // Just show the preview
      setInterimTranscription(text);
    });

    // Final: server sends full transcript so far
    socket.on("transcriptFinal", (msg) => {
      const text = msg.data || "";
      setTranscription(text);
      setInterimTranscription(""); // clear interim
    });

    socket.on("systemInfo", (response) => {
      setIsLoading(response.data === "startLoading");
    });

    return () => {
      socket.off("connect");
      socket.off("connect_error");
      socket.off("mic_status");
      socket.off("transcriptPartial");
      socket.off("transcriptFinal");
      socket.off("systemInfo");
    };
  }, []);

  useEffect(() => {
    window.currentTranscript = transcription;
  }, [transcription]);

  return { isMicAvailable, transcription, interimTranscription, isLoading };
};
